import './locales/register'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

const List = lazy(() => import('./components/List'))
const Update = lazy(() => import('./components/Update'))
const Create = lazy(() => import('./components/Create'))

const JobModule: RouteObject = {
    path: 'jobs',
    children: [
        {
            path: '',
            children: [
                {
                    path: '',
                    element: <List />,
                },
                {
                    path: 'new',
                    element: <Create />,
                },
                {
                    path: ':jobID',
                    element: <Update />,
                },
            ],
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default JobModule
